import type { ReactElement } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { routePaths } from '@/app/route-paths';
import { useIsAuthenticated } from '@/stores/session-store';

/**
 * Unauthenticated visitors land on /start, the one front door (ADR-0031): a
 * phone-registered person cannot sign in on the email screen, but the email
 * screen is one tap from /start, so the redirect works for everyone.
 */
export function RequireAuth(): ReactElement {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={routePaths.phone} state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
